
import React from "react";
import "./AboutPage.css"
import {FiArrowRightCircle} from "react-icons/fi";
import AboutVideo from "../../../Assets/LandingPage/AboutVideo.png";
// import { ReactComponent as AboutVideo} from "../../../Assets/LandingPage/AboutVideo.svg";
import { Link } from "react-router-dom";

const AboutPage = () => {
  return (
    <div>
      <div className="landing-about-container">
        <div className="first-landing-about-box">
          <div className="first-textbox">
            <h2>About NYSC SAED </h2>
            <p>Since 2011, our vision has been to develop a culture of self reliance in our youths for substainable job creation towards National development.</p>
            <p>Our mission is to create a platform that will facilitate acess of young graduates to requisite skills and resources necessary for successful entrepreneurship as a means of enhancing national development.</p>
          </div>
          <img src={AboutVideo} alt="" className="about-video"/>
            {/* <AboutVideo style={{width: "400px"}} />? */}
        </div>
        <Link to ="/about2" ><FiArrowRightCircle className="about-arrow" size={40} style={{color: "#979797"}} /></Link>
      </div>
    </div>
  )
}

export default AboutPage